import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import { TableCell, Tooltip, useTheme } from '@material-ui/core';
import { EditableInput } from './EditableInput';
import styled from 'styled-components';
import { useOverflow } from 'use-overflow';
var StyledTableCell = styled(TableCell).withConfig({
  displayName: "Cell__StyledTableCell",
  componentId: "sc-13d14kg-0"
})(["min-width:80px;", " ", ""], function (_ref) {
  var $width = _ref.$width;
  return $width ? "\n    min-width: ".concat($width, "px;\n    width: ").concat($width, "px;\n    max-width: ").concat($width, "px;\n  ") : '';
}, function (_ref2) {
  var $isCustomCell = _ref2.$isCustomCell;
  return $isCustomCell ? '' : "\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n  ";
});
export var Cell = React.memo(function (_ref3) {
  var dense = _ref3.dense,
      e2e = _ref3.e2e,
      value = _ref3.value,
      column = _ref3.column,
      uniqueKey = _ref3.uniqueKey,
      uniqueValue = _ref3.uniqueValue,
      isEditable = _ref3.isEditable,
      onInputChange = _ref3.onInputChange;
  var theme = useTheme();
  var cellRef = React.useRef(null);

  var _useOverflow = useOverflow(cellRef),
      refXOverflowing = _useOverflow.refXOverflowing;

  if (column.hidden || Array.isArray(value)) return null;
  var output;

  if (column.field === uniqueKey) {
    output = value;
  } else if (isEditable) {
    output = /*#__PURE__*/React.createElement(EditableInput, {
      e2e: e2e,
      type: (column === null || column === void 0 ? void 0 : column.type) || 'string',
      dateFormat: column === null || column === void 0 ? void 0 : column.dateFormat,
      minDate: column === null || column === void 0 ? void 0 : column.minDate,
      maxDate: column === null || column === void 0 ? void 0 : column.maxDate,
      picklistOptions: column === null || column === void 0 ? void 0 : column.picklistOptions,
      value: value,
      picklistUniqueKey: uniqueKey,
      onChange: function onChange(value) {
        return onInputChange({
          value: value,
          column: column
        });
      }
    });
  } else if (column.dsRenderCell) {
    output = column.dsRenderCell({
      rowId: uniqueValue,
      column: column,
      value: value
    });
  } else {
    output = String(value);
  }

  var shouldShowTooltip = !column.dsRenderCell && refXOverflowing;
  var innerCell = /*#__PURE__*/React.createElement(StyledTableCell, _extends({
    $isCustomCell: Boolean(column.dsRenderCell),
    "data-column": column.field,
    size: dense ? 'small' : 'medium'
  }, e2e && {
    'data-e2e': e2e
  }, {
    ref: cellRef,
    $width: column.width
  }), output);

  if (shouldShowTooltip) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      arrow: true,
      interactive: true,
      title: output,
      PopperProps: _objectSpread(_objectSpread({}, e2e && {
        'data-e2e': "".concat(e2e, "-tooltip")
      }), {}, {
        modifiers: {
          offset: {
            enabled: true,
            offset: "0, -".concat(theme.spacing(1))
          }
        }
      })
    }, innerCell);
  }

  return innerCell;
}, function (prevProps, nextProps) {
  var _prevProps$column, _nextProps$column;

  if (prevProps.uniqueValue === nextProps.editableRowUniqueValue) {
    return false;
  }

  if ((prevProps === null || prevProps === void 0 ? void 0 : (_prevProps$column = prevProps.column) === null || _prevProps$column === void 0 ? void 0 : _prevProps$column.dsRenderCell) !== (nextProps === null || nextProps === void 0 ? void 0 : (_nextProps$column = nextProps.column) === null || _nextProps$column === void 0 ? void 0 : _nextProps$column.dsRenderCell)) {
    return false;
  }

  return prevProps.value === nextProps.value && prevProps.isEditable === nextProps.isEditable;
});

try {
  Cell.__docgenInfo = {
    description: '',
    displayName: 'Cell',
    methods: [],
    props: {
      dense: {
        defaultValue: null,
        description: '',
        name: 'dense',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      value: {
        defaultValue: null,
        description: '',
        name: 'value',
        required: true,
        type: {
          name: 'any'
        }
      },
      column: {
        defaultValue: null,
        description: '',
        name: 'column',
        required: true,
        type: {
          name: 'any'
        }
      },
      uniqueKey: {
        defaultValue: null,
        description: '',
        name: 'uniqueKey',
        required: true,
        type: {
          name: 'string'
        }
      },
      isEditable: {
        defaultValue: null,
        description: '',
        name: 'isEditable',
        required: true,
        type: {
          name: 'boolean'
        }
      },
      uniqueValue: {
        defaultValue: null,
        description: '',
        name: 'uniqueValue',
        required: true,
        type: {
          name: 'string'
        }
      },
      editableRowUniqueValue: {
        defaultValue: null,
        description: '',
        name: 'editableRowUniqueValue',
        required: false,
        type: {
          name: 'string'
        }
      },
      onInputChange: {
        defaultValue: null,
        description: '',
        name: 'onInputChange',
        required: true,
        type: {
          name: '(args: { value: any; column: any; }) => void'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=Cell.js.map